document.addEventListener('DOMContentLoaded', () => {
    // Open Rebuy Smart Cart when the sticky cart button is clicked
    document.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-rebuy-cart-button]');
        if (!btn) return;

        e.preventDefault();

        // If Rebuy is loaded, open its Smart Cart
        if (window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.show === 'function') {
            console.log('Rebuy Opened 7')
            window.Rebuy.SmartCart.show();
        }
    });
});


(function () {
    // ---- CONFIG ------------------------------------------------------------
    let ENABLED = typeof window.isRebuyCartEnabled === 'boolean'
    ? window.isRebuyCartEnabled
    : false;

    // Toggle this in console to see logs: window.DEBUG_REBUY = true;
    window.DEBUG_REBUY = window.DEBUG_REBUY || false;

    // All selectors you want to keep in sync:
    let COUNT_SELECTORS = [
    '.cart-count',
    '.cart-count-bubble',
    '[data-cart-count]',
    '[data-cart-bubble]'
    ];

    // ---- UTILITIES ---------------------------------------------------------
    function log() { if (window.DEBUG_REBUY) console.log('[rebuy-count]', ...arguments); }

    // Debounce to avoid spamming DOM updates when multiple events fire
    let t;
    function debounce(fn, wait) {
    return function () {
        let args = arguments;
        clearTimeout(t);
        t = setTimeout(function () { fn.apply(null, args); }, wait || 80);
    };
    }

    function coerceNumber(n, fallback) {
    let x = Number(n);
    return Number.isFinite(x) ? x : (fallback || 0);
    }

    // Try to read item count from various cart shapes
    function getCountFromAnyCart(cartLike) {
    if (!cartLike) return null;

    // Rebuy sometimes provides the cart directly OR wrapped (e.detail.cart)
    let cart = cartLike.cart || cartLike;

    // Common properties:
    if (typeof cart.item_count === 'number') return cart.item_count;
    if (Array.isArray(cart.items)) {
        return cart.items.reduce(function (sum, i) {
        return sum + coerceNumber(i.quantity, 0);
        }, 0);
    }
    return null;
    }

    // Fallback to Shopify /cart.js (works regardless of Rebuy)
    function fetchShopifyCartCount() {
    return fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
        let count = getCountFromAnyCart(cart);
        log('Fetched from /cart.js:', count, cart);
        return coerceNumber(count, 0);
        })
        .catch(function (e) {
        log('Fetch /cart.js failed', e);
        return 0;
        });
    }

    function renderCartCount(count) {
    COUNT_SELECTORS.forEach(function (sel) {
        document.querySelectorAll(sel).forEach(function (el) {
        // text
        el.textContent = String(count);
        // attributes some themes rely on
        el.setAttribute('data-cart-count', String(count));
        el.setAttribute('aria-label', String(count));

        // optional empty/not-empty class toggle
        if (count > 0) el.classList.add('is-not-empty');
        else el.classList.remove('is-not-empty');
        });
    });
    }

    let applyCount = debounce(function (maybeCart) {
    // Prefer event payload; fallback to /cart.js
    let count = getCountFromAnyCart(maybeCart);
    if (count === null) {
        fetchShopifyCartCount().then(renderCartCount);
    } else {
        renderCartCount(coerceNumber(count, 0));
    }
    }, 50);

    // ---- WIRE UP EVENTS ----------------------------------------------------
    // Always register listeners; we gate updates by ENABLED in the handler.
    function handle(e) {
    if (!ENABLED) return;
    let payload = e && e.detail ? e.detail : null;
    log('Event', e.type, payload);
    applyCount(payload);
    }

    // Rebuy custom events (cover initial load + any changes)
    document.addEventListener('rebuy:cart.ready', handle);
    document.addEventListener('rebuy:cart.change', handle);
    document.addEventListener('rebuy:cart.add', handle);
    document.addEventListener('rebuy:cart.remove', handle);

    // Some themes/apps fire generic events—hook those too
    document.addEventListener('cart:updated', handle);
    document.addEventListener('cart:change', handle);

    // Initial paint (so header count is correct on first load/refresh)
    document.addEventListener('DOMContentLoaded', function () {
    if (!ENABLED) return;
    fetchShopifyCartCount().then(renderCartCount);
    });

    // Last-resort MutationObserver (detects qty changes in the drawer DOM)
    // Adjust the selector below to match the Rebuy cart drawer container in your theme.
    let drawerSelectorCandidates = [
    '#rebuy-cart-drawer',
    '[data-rebuy-cart]',
    '.rebuy-cart',
    '.rebuy-cart-drawer'
    ];
    let drawerEl = drawerSelectorCandidates.map(function (s) { return document.querySelector(s); }).find(Boolean);

    if (drawerEl) {
    let mo = new MutationObserver(debounce(function () {
        if (!ENABLED) return;
        // When DOM mutates (qty inputs/buttons), refresh from /cart.js
        fetchShopifyCartCount().then(renderCartCount);
    }, 120));
    mo.observe(drawerEl, { childList: true, subtree: true, attributes: true });
    }
})();
